import styled, { css } from 'styled-components';

import { defaultThemeProp } from '../../theme';

const StyledTextArea = styled.textarea<{ resizable: boolean; autoResize: boolean }>(
  ({ resizable, autoResize }) => {
    return css`
      width: 100%;
      min-height: ${props => props.theme.components['text-area']['min-height']};
      padding: ${props => props.theme.components['text-area'].padding};
      appearance: none;
      ${autoResize &&
      css`
        height: var(--textarea-height, auto);
      `}
      ${resizable
        ? css`
            resize: vertical;
            overflow: hidden;
          `
        : css`
            resize: none;
            overflow: auto;
            max-height: 90vh;
          `}
    `;
  }
);

StyledTextArea.defaultProps = defaultThemeProp;

export default StyledTextArea;
